import { API_PREFIX } from './constant'
import { Request } from './request'

/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-05-19 14:44:27
 * @LastEditors: linxi
 * @LastEditTime: 2023-06-06 11:42:31
 */
export interface ImageInformationParams {
  patientId?: any
  current: number
  size: number
  endTime?: string
  startTime?: string
}

// 列表
export function ImageInformationPage(params: ImageInformationParams): Request {
  return {
    url: `${API_PREFIX}/blade-outpatient/treatment/getImgList`,
    method: 'GET',
    params,
  }
}
